module.exports = __webpack_public_path__ + "img/product_bg_new_03.acfe7a1.webp";